import Input from "../../../../ui-components/Input";
import React from "react";
import { Discount1EditorProps } from "./types";
import { FormattedMessage } from "react-intl";
import { DiscountRule1Props } from "../../types";
import AuthenticationService from "../../../../services/AuthenticationService";


const transportUmComponent = (ums: string[]) => {
  const unique = Array.from(new Set(ums));
  const symbolsCls = "text-gray-300 font-semibold";
  return (
    <p className="flex flex-row gap-0.5">
      <span>&euro;</span>
      <span>/</span>
      {unique.length > 1 && <span className={symbolsCls}>[</span>}
      {unique.map((um, i) => <>
        <span>{um}</span>
        {i < unique.length - 1 && <span className={symbolsCls}>|</span>}
      </>)}
      {unique.length > 1 && <span className={symbolsCls}>]</span>}
    </p>
  )
}


const PARTS = {
  discount_1: {
    required: true,
    direction: "-",
    um: () => "%",
  },
  discount_2: {
    required: false,
    direction: "-",
    um: () => "%",
  },
  discount_3: {
    required: false,
    direction: "-",
    um: () => "%",
  },
  marginality: {
    required: false,
    direction: "+",
    um: () => "%",
  },
  transport_eur_kg: {
    required: false,
    direction: "+",
    um: transportUmComponent,
  },
};

export const Discount1Editor = ({
  value,
  onChange,
  productMus,
  editable,
  ...rest
}: Discount1EditorProps) => {


  const userScopes = AuthenticationService.getUserScopes();


  const isInputHidden = (part: string) => {

    switch (part) {
      case "discount_1":
      case "discount_2":
      case "discount_3":
        return !userScopes.includes("quotation:apply_discount")
      case "marginality":
        return !userScopes.includes("quotation:apply_marginality")
    }
  }

  return (
    <>
      <div className="grid grid-cols-3 gap-x-6 gap-y-2">
        {Object.entries(PARTS).map(([part, partOptions], idx) => {
          if (isInputHidden(part))
            return;
          const key = `discount_rule_1__${part}`;
          return (
            <div key={idx}>
              <div className="flex flex-row gap-2 justify-between items-center">
                <div className="flex flex-row gap-1.5">
                  <span className="font-semibold">
                    <FormattedMessage id={key} />
                  </span>
                  <span className={`font-semibold ${partOptions.direction === "+" ? "text-green-500" : "text-red-500"}`}>
                    {partOptions.direction === "+" ? "+" : <>&minus;</>}
                  </span>
                </div>
                {partOptions.required && (
                  <span className="text-xs font-light text-gray-500">
                    <FormattedMessage
                      id="required"
                      defaultMessage="Obbligatorio"
                    />
                  </span>
                )}
              </div>
              <div className="flex items-center gap-2">
                {/* @ts-ignore */}
                <Input
                  type="number"
                  value={value[part as keyof DiscountRule1Props]}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    onChange({
                      ...value,
                      [part]: !!e.target.value
                        ? parseFloat(e.target.value)
                        : null,
                    })
                  }
                  disabled={!editable}
                  name={key}
                  showErrorDialog={false}
                  {...partOptions}
                  {...rest}
                />
                <span className="flex-1">
                  {partOptions.um(productMus)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
